import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import React from 'react';
import { observer } from 'mobx-react';
// locals
import Tooltip from '../../Tooltip';
import { toP } from '../../util';
var en = function en(n) {
  return n.toLocaleString('en-US');
};
var TooltipContents = React.forwardRef(function (_ref, ref) {
  var feature = _ref.feature;
  var start = feature.get('start');
  var end = feature.get('end');
  var name = feature.get('refName');
  var loc = [name, start === end ? en(start) : "".concat(en(start), "..").concat(en(end))].filter(function (f) {
    return !!f;
  }).join(':');
  return feature.get('summary') !== undefined ? React.createElement("div", {
    ref: ref
  }, loc, React.createElement("br", null), "Max: ", toP(feature.get('maxScore')), React.createElement("br", null), "Avg: ", toP(feature.get('score')), React.createElement("br", null), "Min: ", toP(feature.get('minScore'))) : React.createElement("div", {
    ref: ref
  }, loc, React.createElement("br", null), "".concat(toP(feature.get('score'))));
});
var WiggleTooltip = observer(function (props) {
  return React.createElement(Tooltip, _objectSpread({
    TooltipContents: TooltipContents
  }, props));
});
export default WiggleTooltip;
export { Tooltip };